import { DEVELOPER_PROJ_STATUS, DeveloperProjectStatusString } from "../../../../constants/developer_proj_status.jsx";

export const ProjectStatus = ({ value }) => {
  const statusText = DeveloperProjectStatusString[value];

  const getStatusStyle = (status) => {
    switch (status) {
      case DEVELOPER_PROJ_STATUS.Active:
        return { backgroundColor: "#55FF00", color: "black" }; // Green
      case DEVELOPER_PROJ_STATUS.Suspended:
        return { backgroundColor: "#FF0000", color: "black" }; // Red
      case DEVELOPER_PROJ_STATUS.Pending_Release:
        return { backgroundColor: "#FF9D00", color: "black" }; // Orange
    }
  };
  const style = {
    ...getStatusStyle(value),
    padding: "5px",
    borderRadius: "15px",
    margin: "5px",
    fontWeight: "500",
    paddingLeft: "10px",
    paddingRight: "10px",
    minWidth: "90px",
    textAlign: "center",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return <span style={style}>{statusText}</span>;
};
